import { render, staticRenderFns } from "./MonochromePieMulti.vue?vue&type=template&id=e9dbde4e&scoped=true&"
import script from "./MonochromePieMulti.vue?vue&type=script&lang=js&"
export * from "./MonochromePieMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dbde4e",
  null
  
)

export default component.exports